import React from 'react'
import { createRoot } from 'react-dom/client'
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react'
import { createStandaloneToast } from '@chakra-ui/toast'
import { themeMercedes } from 'theme'

import '@fontsource/montserrat'

import App from './App'

const { ToastContainer } = createStandaloneToast({ theme: themeMercedes })

const root = createRoot(document.getElementById('app')!)

root.render(
  <ChakraProvider resetCSS theme={themeMercedes}>
    <ColorModeScript initialColorMode={themeMercedes.config.initialColorMode} />
    <App />
    <ToastContainer />
  </ChakraProvider>
)
